import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { JwtInterceptor, ErrorInterceptor } from "app/auth/helpers";
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import { AuthGuard } from "app/auth/helpers/auth.guards";
import "hammerjs";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ToastrModule } from "ngx-toastr"; // For auth after login toast

import { CoreModule } from "@core/core.module";
import { CoreCommonModule } from "@core/common.module";
import { CoreSidebarModule, CoreThemeCustomizerModule } from "@core/components";

import { coreConfig } from "app/app-config";

import { AppComponent } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";
import { SampleModule } from "app/main/sample/sample.module";

import { NgxDatatableModule } from "@swimlane/ngx-datatable";

import { UserListService } from "./main/apps/user/user-list/user-list.service";
import { UserViewService } from "./main/apps/user/user-view/user-view.service";
import { UserEditService } from "./main/apps/user/user-edit/user-edit.service";
import { ProfileService } from "./main/goalngo/profile/profile.service";

import { AnalyticsComponent } from "./main/goalngo/posts/analytics/analytics.component";

import { CardSnippetModule } from "@core/components/card-snippet/card-snippet.module";
import { CommonModule } from "@angular/common";

import { AdminListComponent } from "./main/goalngo/users/admin-list/admin-list.component";

import { NotificationComponent } from "./main/goalngo/notification/notification.component";
import { AddNotificationComponent } from "./main/goalngo/add-notification/add-notification.component";

import { EditPlayerComponent } from "./main/goalngo/users/edit-player/edit-player.component";
import { ProfileComponent } from "./main/goalngo/users/profile/profile.component";

import { NgApexchartsModule } from "ng-apexcharts";

import { AskAiComponent } from "./main/goalngo/ask-ai/ask-ai.component";
import { UserServiceComponent } from "./main/goalngo/user-service/user-service.component";

import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { PendingDetailsComponent } from "./main/goalngo/pending-details/pending-details.component";
import { LoadingComponent } from "./services/shared/loading/loading.component";
import { VerificationComponent } from "./main/goalngo/verification/verification.component";
import { ServiceDetailssComponent } from "./main/goalngo/user-service/service-detailss/service-detailss.component";
import { UserNotificationsComponent } from "./main/goalngo/user-notifications/user-notifications.component";
import { SendNotificationsComponent } from "./main/goalngo/send-notifications/send-notifications.component";

import { PaymentInfoComponent } from "./main/goalngo/payment-info/payment-info.component";
import { ProfileOfferDetailsComponent } from "./main/goalngo/profile-offers/profile-offer-details/profile-offer-details.component";
import { NgxDropzoneModule } from "ngx-dropzone";
import { BranchesComponent } from "./main/goalngo/branches/branches.component";
import { AddBranchesComponent } from "./main/goalngo/branches/add-branches/add-branches.component";
import { EditBranchesComponent } from "./main/goalngo/branches/edit-branches/edit-branches.component";
import { PlanTypesComponent } from "./main/goalngo/plan-types/plan-types.component";
import { UploadRefundReceiptComponent } from "./main/goalngo/upload-refund-receipt/upload-refund-receipt.component";
import { TransferedTransactionsComponent } from "./main/goalngo/payment/finance/transfered-transactions/transfered-transactions.component";

const appRoutes: Routes = [
  {
    path: "analytics",
    component: AnalyticsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "",
    redirectTo: "/analytics",
    pathMatch: "full",
    canActivate: [AuthGuard],
  },

  {
    path: "upload-refund-receipt/:id/:payoutAccountId",
    component: UploadRefundReceiptComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "transfered-transactions/:userId",
    component: TransferedTransactionsComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "notifications",
    component: NotificationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "notify",
    component: AddNotificationComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "edit-info/:id",
    component: EditPlayerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "profile/:id",
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },

  { path: "ask-ai", component: AskAiComponent, canActivate: [AuthGuard] },
  {
    path: "user/:id/services",
    component: UserServiceComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "verification",
    component: VerificationComponent,
    canActivate: [AuthGuard],
  },

  { path: "branches", component: BranchesComponent, canActivate: [AuthGuard] },
  {
    path: "add-branches",
    component: AddBranchesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "edit-branches",
    component: EditBranchesComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "pending-details/:id",
    component: PendingDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "service-detailss/:id",
    component: ServiceDetailssComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "user/:id/notifications",
    component: UserNotificationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "send-notifications/:id",
    component: SendNotificationsComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "payment-info/:id",
    component: PaymentInfoComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "gino",
    loadChildren: () => import("./main/goalngo/gino/gino.module").then((m) => m.GinoModule),
  },

  {
    path: "go-service",
    loadChildren: () => import("./main/goalngo/goService/go-service.module").then((m) => m.GoServiceModule),
  },

  {
    path: "users",
    loadChildren: () => import("./main/goalngo/users-module/users/users.module").then((m) => m.UsersModule),
  },

  {
    path: "go-reach",
    loadChildren: () => import("./main/goalngo/go-reach/go-reach.module").then((m) => m.GoReachModule),
  },

  {
    path: "posts",
    loadChildren: () => import("./main/goalngo/posts/posts.module").then((m) => m.PostsModule),
  },
  {
    path: "accounting",
    loadChildren: () => import("./main/goalngo/payment/payment.module").then((m) => m.PaymentModule),
  },

  {
    path: "shared",
    loadChildren: () => import("./main/goalngo/shared/shared.module").then((m) => m.SharedModule),
  },

  {
    path: "sports-entities",
    loadChildren: () =>
      import("./main/goalngo/sports-entities/sports-entities.module").then((m) => m.SportsEntitiesModule),
  },

  {
    path: "subscription",
    loadChildren: () => import("./main/goalngo/subscription/subscription.module").then((m) => m.SubscriptionModule),
  },

  {
    path: "privileges",
    loadChildren: () => import("./main/goalngo/privileges/privileges.module").then((m) => m.PrivilegesModule),
  },

  {
    path: "go-hire",
    loadChildren: () =>
      import("./main/goalngo/hire-jobs-admin/hire-jobs-admin.module").then((m) => m.HireJobsAdminModule),
  },

  {
    path: "settings",
    loadChildren: () => import("./main/goalngo/general-settings/settings.module").then((m) => m.SettingsModule),
  },

  {
    path: "pages",
    loadChildren: () => import("./main/pages/pages.module").then((m) => m.PagesModule),
  },
  {
    path: "**",
    redirectTo: "/pages/miscellaneous/error", //Error 404 - Page not found
  },
];

@NgModule({
  declarations: [
    AppComponent,
    AnalyticsComponent,
    AdminListComponent,

    NotificationComponent,
    AddNotificationComponent,
    ProfileComponent,
    EditPlayerComponent,

    AskAiComponent,
    UserServiceComponent,

    VerificationComponent,
    PendingDetailsComponent,

    LoadingComponent,
    ServiceDetailssComponent,
    UserNotificationsComponent,
    SendNotificationsComponent,

    PaymentInfoComponent,

    BranchesComponent,
    AddBranchesComponent,
    EditBranchesComponent,
    PlanTypesComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbNavModule,
    CardSnippetModule,
    CommonModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: "enabled", // Add options right here
      relativeLinkResolution: "legacy",
      preloadingStrategy: PreloadAllModules,
    }),
    TranslateModule.forRoot(),

    //NgBootstrap
    NgbModule,
    ToastrModule.forRoot(),

    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,

    // App modules
    LayoutModule,
    SampleModule,

    NgxDatatableModule,
    NgApexchartsModule,
    NgxSliderModule,
    NgxDropzoneModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    UserListService,
    UserViewService,
    UserEditService,
    ProfileService,
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
